import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding-top: 14px;

  .component_ad_widget_wrapper {
    padding: ${(props) => {
      return props.padding;
    }};
  }
`;

export default Wrapper;

export const AdDetailWrapper = styled.div`
  padding: 24px;
`;

export const AdWidgetDrawer = styled.div`
  display: ${({ show }) => {
    return show ? 'flex' : 'none';
  }};
  overflow: hidden;
  height: 100vh;
  width: 600px;
  background-color: ${color.grey5};
  position: fixed;
  right: 0;
  top: 0;
  z-index: 50;
  flex-direction: column;
  .component_ad_detail_header {
    padding: 24px;
    .anticon {
      font-size: 16px;
      color: ${color.black2};
      cursor: pointer;
    }
  }
`;
